import React, { useState, useEffect } from "react";
import axios from "axios";
import { Router, navigate } from "@reach/router";
import useAuth from "../auth/hooks/useAuth";
import Header from "../header";
import Assignments from "../assignments";
import Clash from "../clash";
import War from "../war";
import GamesScreen from "../games";
import YourEmile from "../your_emile";
import MeetEmile from "../meet_emile";
import Trophies from "../trophies";
import Rank from "../ranks";
import YourStory from "../story";
import { HubContainer } from "./styled_components/containers";
import { Loading } from "../../globals/components/loading";
import { Scale } from 'react-scaling';

function Hub() {
  const { state, dispatch } = useAuth();
  const { pupil, access_token } = state;
  const [hasImportantAssignment, setHasImportantAssignment] = useState(false);
  const [incompleteCount, setIncompleteCount] = useState(0);

  const [hasClash, setHasClash] = useState(false);
  const [clashCount, setClashCount] = useState(0);

  useEffect(() => {
    if (window.location.pathname == "/trial"){
      navigate ("/");
    }
    if (window.location.pathname !== "/" && window.location.pathname !== "/trial") {
      navigate(window.location.pathname);
    } else {
      navigate("/games");
    }
  }, []);

  useEffect(() => {
    const getPupilDetails = async () => {
      try {
        const response = await axios({
          url: `${process.env.REACT_APP_OAUTH_URL}/api/details`,
          method: "get",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${access_token}`
          }
        });
        dispatch({
          type: "update_pupil",
          payload: response.data
        });
      } catch (e) {
        throw new Error(e);
      }
    };

    getPupilDetails();
  }, []);

  
  function UpdateImportant(input, count) {
    setHasImportantAssignment(input);
    console.log("UpdateImportant" + input);
    setIncompleteCount(count);
  }

  function UpdateClash(input, count){
    setHasClash(input);
    console.log("Clash update" + input);
    setClashCount(count);
  }


  return (
    <HubContainer>
      {pupil === null && (
        <Loading
          background={true}
          message={"Please wait whilst we load your details..."}
        />
      )}
       <Scale scaleTo={1920}>
      <Header pupil={pupil} importantAssignment={hasImportantAssignment} incompleteCount={incompleteCount} hasClash={hasClash} clashCount={clashCount}/>
      </Scale>
      <Router style={{ height: "100%", overflow: "hidden" }}>
        <GamesScreen hasImportant={hasImportantAssignment} path="games/*" />
        <YourEmile path="your-emile" />
        <MeetEmile path="meet-emile" />
        <Trophies path="trophies" />
        <Rank path="ranks" />
        <Assignments path="assignments" update={UpdateImportant} clashupdate={UpdateClash} />
        <Clash path="clash" update={UpdateImportant} clashupdate={UpdateClash} />
        <YourStory path="story"/>
        <War path="war" update={UpdateImportant} clashupdate={UpdateClash}/>
      </Router>
    </HubContainer>
  );
}

export default Hub;
